import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './Navbar.module.css';

const notionLink = 'https://cancercompass.notion.site/Cancer-Compass-Downloads-7c7c91844c474d4a8b88fd699b082f5d'
const menuItems = [
  {
    name: "Home",
    subMenu: ["Home", "Contributor", "Citation"],
    link: ["/", "/", "/"],
  },
  {
    name: "Pathway Analysis",
    subMenu: ["ORA(Cancer)","ORA(Immune)"],
		link: ["/ORA", "/ORA_immune"],
  },
	{
    name: "Pathway Prioritization",
    subMenu: ["PP(Cancer)", "PP(Immune)",],
		link: ["/CP", "/CP_immune"],
  },
  { name: "Download" , webLink : notionLink},
];

const NavBar= () => {
  const [activeMenu, setActiveMenu] = useState(null);
	const navigate = useNavigate();

  return (
    <nav>
			<div className={styles.section}>
				<div className={styles.logo} onClick={() => {navigate('/')} }>CANCER COMPASS</div>
				<ul className={styles.navLinks}>
					{menuItems.map((item, index) => (
						item.link 
						?	
						<li className={styles.mainItem} key={index} 
						onMouseEnter={() => setActiveMenu(item.name)}
						onMouseLeave={() => setActiveMenu(null)}>
							{item.name}
							{activeMenu === item.name && item.subMenu && item.link && (
								<ul className={`${styles.dropdown} ${activeMenu === item.name ? styles.clicked : ''}`}>
									{item.subMenu.map((subItem, subIndex) => (
										<li key={subIndex}  onClick={() => navigate(item.link[subIndex])}>{subItem}</li>
									))}
								</ul>
							)}
						</li>
						:
						<li className={styles.mainItem} key={index} 
						onMouseEnter={() => setActiveMenu(item.name)}
						onMouseLeave={() => setActiveMenu(null)}
						onClick={() => {window.open(item.webLink, '_blank');}}
						>
							{item.name}
						</li>
					
					))}
				</ul>
			</div>
    </nav>
  );
};

export default NavBar;
